module.exports = __webpack_public_path__ + "static/img/v0.abfacb0.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/v0.png
// module id = 7AV6
// module chunks = 1